export const capitalize = (text: string) =>
  text.length > 1 ? `${text.charAt(0).toUpperCase()}${text.substr(1)}` : text.toUpperCase();

/**
 * Translates boolean string values ('true'/'false') to localized 'Yes'/'No' using i18n.
 * Returns the original value if it's not a boolean string.
 * Can be used for any boolean string translation needs (TrialLens, checkboxes, flags, etc.).
 *
 * @param value - The string value to translate
 * @param t - The i18n translate function
 * @returns Translated 'Yes' for true, 'No' for false, or original value
 */
export const translateBoolean = (value: string, t: (key: string) => string): string => {
  const normalized = value ? value.trim().toLowerCase() : '';
  if (normalized === 'true') {
    return t('platform.common.yes');
  }
  if (normalized === 'false') {
    return t('platform.common.no');
  }
  return value;
};

/**
 * Capitalizes boolean string values ('true'/'false') to 'True'/'False'.
 * Returns the original value if it's not a boolean string.
 *
 * @param value - The string value to capitalize
 * @returns Capitalized boolean string or original value
 */
export const capitalizeBoolean = (value: string): string => {
  const normalized = value ? value.trim().toLowerCase() : '';
  if (normalized === 'true' || normalized === 'false') {
    return capitalize(normalized);
  }
  return value;
};
